/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
// @ts-ignore
import {
  WhatToDoIcon,
  WhatToSeeIcon,
  WhereToEatIcon,
  WhereToSleepIcon,
  LocalProductsIcon,
  ServicesIcon,
  AgendaIcon,
  MenuItem,
} from "@davi-ai/retorik-framework-hospitality";
import React from "react";
import { sendEvent } from "@davi-ai/retorik-framework";

const buildCustomMenu = (customMenu: any[], handleClick: Function): any[] => {
  customMenu.push(
    new WhatToDoItem(
      1,
      handleClick,
      undefined,
      translation.whatToDo
    ).getAsCustomMenu()
  );
  customMenu.push(
    new WhereToEatItem(
      2,
      handleClick,
      undefined,
      translation.whereToEat
    ).getAsCustomMenu()
  );
  customMenu.push(
    new WhereToSleepItem(
      3,
      handleClick,
      undefined,
      translation.whereToSleep
    ).getAsCustomMenu()
  );
  customMenu.push(
    new WhatToSeeItem(
      3,
      handleClick,
      undefined,
      translation.whatToSee
    ).getAsCustomMenu()
  );

  customMenu.push(
    new LocalProductsItem(
      4,
      handleClick,
      undefined,
      translation.localProducts
    ).getAsCustomMenu()
  );

  customMenu.push(
    new ServicesItem(
      4,
      handleClick,
      undefined,
      translation.services
    ).getAsCustomMenu()
  );
  // customMenu.push(
  //   new AgendaItem(
  //     0,
  //     handleClick,
  //     undefined,
  //     translation.agenda
  //   ).getAsCustomMenu()
  // );
  return customMenu;
};
export { buildCustomMenu };

// class AgendaItem extends MenuItem {
//   constructor(indice, sendActivity, color, label) {
//     super(indice, label, undefined, undefined, true, "agenda");

//     this.clickHandler = (): void => {
//       const activity = {
//         type: "event",
//         //name: "Hospitality.ShowAllTouristAttractions",
//         name: "hospitality.ShowAllContentItems",
//         value:{
//           filterId: "AllFireOrganization"
//         }
//       };
//       sendEvent("hospitality.showAllContentItems", { filterId: "AllWaterOrganization", filterValue: ""});
//     };

//     this.icon = React.createElement("img", { src: "images/fire-icon.png", alt: "" });
//   }
// }

class LocalProductsItem extends MenuItem {
  constructor(indice, sendActivity, color, label) {
    super(indice, label, undefined, undefined, true, "localProducts");

    this.clickHandler = (): void => {
      const activity = {
        type: "event",
        //name: "Hospitality.ShowAllTouristAttractions",
        name: "hospitality.ShowAllContentItems",
        value: {
          filterId: "AllWoodOrganization",
        },
      };
      sendEvent("hospitality.showAllContentItems", {
        filterId: "AllWoodOrganization",
        filterValue: "",
      });
    };

    this.icon = React.createElement("img", {
      src: "https://studio.retorik.ai/mejstjegx80had7vep/media/icon/svg/filiere-bois.svg",
      className: "rf-h-full rf-w-full",
      style: { color: "red", fill: "none", stroke: "red" },
    });
  }
}

class ServicesItem extends MenuItem {
  constructor(indice, sendActivity, color, label) {
    super(indice, label, undefined, undefined, true, "services");

    this.clickHandler = (): void => {
      sendEvent("hospitality.showAllContentItems", {
        filterId: "AllOtherOrganization",
        filterValue: "",
      });
    };

    this.icon = React.createElement("img", {
      src: "https://studio.retorik.ai/mejstjegx80had7vep/media/icon/svg/trophee.svg",
      className: "rf-h-full rf-w-full",
      style: { color: "red", fill: "none", stroke: "red" },
    });
  }
}

class WhatToDoItem extends MenuItem {
  constructor(indice, sendEvent, color, label) {
    super(indice, label, undefined, undefined, true, "whatToDo");

    this.clickHandler = (): void => {
      const activity = {
        type: "event",
        //name: "Hospitality.ShowAllTouristAttractions",
        name: "hospitality.ShowAllContentItems",
        value: {
          filterId: "AllFireOrganization",
        },
      };
      sendEvent("hospitality.showAllContentItems", {
        filterId: "AllFireOrganization",
        filterValue: "",
      });
    };

    this.icon = React.createElement("img", {
      src: "https://studio.retorik.ai/mejstjegx80had7vep/media/icon/svg/feu.svg ",
      className: "rf-h-full rf-w-full",
      style: { color: "red", fill: "none", stroke: "red" },
    });

    //this.icon = WhatToDoIcon({ className: "rf-h-full rf-w-full", color });

    //this.icon = React.createElement("svg", { src: "images/fire-svgrepo-com.svg", className: "rf-h-full rf-w-full", fill: "red" });

    //this.icon = WhatToDoIcon({ className: "rf-h-full rf-w-full", color });
  }
}

class WhatToSeeItem extends MenuItem {
  constructor(indice, sendActivity, color, label) {
    super(indice, label, undefined, undefined, true, "whatToSee");

    this.clickHandler = (): void => {
      const activity = {
        type: "event",
        //name: "Hospitality.ShowAllTouristAttractions",
        name: "hospitality.ShowAllContentItems",
        value: {
          filterId: "AllWaterOrganization",
        },
      };
      sendEvent("hospitality.showAllContentItems", {
        filterId: "AllWaterOrganization",
        filterValue: "",
      });
    };

    this.icon = React.createElement("img", {
      src: "https://studio.retorik.ai/mejstjegx80had7vep/media/icon/svg/eau.svg",
      className: "rf-h-full rf-w-full",
      style: { color: "red", fill: "none", stroke: "red" },
    });
  }
}

class WhereToEatItem extends MenuItem {
  constructor(indice, sendActivity, color, label) {
    super(indice, label, undefined, undefined, true, "whereToEat");

    this.clickHandler = (): void => {
      const activity = {
        type: "event",
        //name: "Hospitality.ShowAllTouristAttractions",
        name: "hospitality.ShowAllContentItems",
        value: {
          filterId: "AllWindOrganization",
        },
      };
      sendEvent("hospitality.showAllContentItems", {
        filterId: "AllWindOrganization",
        filterValue: "",
      });
    };
    this.icon = React.createElement("img", {
      src: "https://studio.retorik.ai/mejstjegx80had7vep/media/icon/svg/train.svg",
      className: "rf-h-full rf-w-full",
      style: { color: "red", fill: "none", stroke: "red" },
    });
  }
}

class WhereToSleepItem extends MenuItem {
  constructor(indice, sendActivity, color, label) {
    super(indice, label, undefined, undefined, true, "whereToSleep");

    this.clickHandler = (): void => {
      const activity = {
        type: "event",
        //name: "Hospitality.ShowAllTouristAttractions",
        name: "hospitality.ShowAllContentItems",
        value: {
          filterId: "AllDirtOrganization",
        },
      };
      sendEvent("hospitality.showAllContentItems", {
        filterId: "AllDirtOrganization",
        filterValue: "",
      });
    };

    this.icon = React.createElement("img", {
      src: "https://studio.retorik.ai/mejstjegx80had7vep/media/icon/svg/terre.svg",
      className: "rf-h-full rf-w-full",
      style: { color: "red", fill: "none", stroke: "red" },
    });
  }
}

const translation = {
  whatToDo: {
    "fr-FR": "Feu/métal",
    "en-US": "fire/metal",
    "en-GB": "fire/metal",
    "es-ES": "fire/metal",
    "de-DE": "fire/metal",
  },
  whatToSee: {
    "fr-FR": "eau",
    "en-US": "water",
    "en-GB": "water",
    "es-ES": "water",
    "de-DE": "wasser",
  },
  whereToSleep: {
    "fr-FR": "terre",
    "en-US": "earth",
    "en-GB": "earth",
    "es-ES": "earth",
    "de-DE": "erde",
  },
  whereToEat: {
    "fr-FR": "air",
    "en-US": "air",
    "en-GB": "air",
    "es-ES": "air",
    "de-DE": "luft  ",
  },
  localProducts: {
    "fr-FR": "bois",
    "en-US": "wood",
    "en-GB": "wood",
    "es-ES": "wood",
    "de-DE": "holz",
  },
  services: {
    "fr-FR": "autre réussites",
    "en-US": "other achievements",
    "en-GB": "other achievements",
    "es-ES": "other achievements",
    "de-DE": "andere Erfolge",
  },
  agenda: {
    "fr-FR": "Le calendrier des compétitions",
    "en-US": "The competitions schedule",
    "en-GB": "schedule",
    "es-ES": "schedule",
    "de-DE": "Kalender",
  },
};
